import { PENDING_ADD_TO_CART_KEY } from '@fdc/constants/cart.constants';
import { isRecord } from '@fdc/utils/type-guards';

import { sessionStorageService } from '@contentservice/shared/services/storage/session-storage.service';

export interface PendingAddToCartPayload {
  productId: string;
  value: number;
  variantKey: string;
  isAlcoholAgeRestricted: boolean;
}

const isPendingAddToCartPayload = (
  value: unknown
): value is PendingAddToCartPayload => {
  if (!isRecord(value)) {
    return false;
  }

  const productId = value['productId'];
  const storedValue = value['value'];
  const variantKey = value['variantKey'];
  const isAlcoholAgeRestricted = value['isAlcoholAgeRestricted'];

  return (
    typeof productId === 'string' &&
    typeof storedValue === 'number' &&
    typeof variantKey === 'string' &&
    typeof isAlcoholAgeRestricted === 'boolean'
  );
};

export const persistPendingAddToCart = (
  payload: PendingAddToCartPayload
): void => {
  sessionStorageService.set(PENDING_ADD_TO_CART_KEY, JSON.stringify(payload));
};

export const clearPendingAddToCart = (): void => {
  sessionStorageService.remove(PENDING_ADD_TO_CART_KEY);
};

export const getPendingAddToCart = (): PendingAddToCartPayload | null => {
  const stored = sessionStorageService.get(PENDING_ADD_TO_CART_KEY);

  if (!stored) {
    return null;
  }

  try {
    const parsedValue: unknown = JSON.parse(stored);

    if (isPendingAddToCartPayload(parsedValue)) {
      return parsedValue;
    }

    clearPendingAddToCart();
    return null;
  } catch {
    clearPendingAddToCart();
    return null;
  }
};
